import { Routes } from "@generouted/react-router";
import { MantineProvider } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "@mantine/core/styles.css";
import "./App.css";
import { CsrfTokenContextProvider } from "./providers/csrfToken";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider>
        <CsrfTokenContextProvider>
          <Routes />
        </CsrfTokenContextProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default App;
